<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { icons } from "@/modules/explorer/components/icons";

const selectedIcon = defineModel<string>();
const iconSearch = ref("");
const itemsPerPage = 99;
const page = ref(1);
const isDialogVisible = ref(false);

watch(iconSearch, () => {
	page.value = 1;
});

const saveIcon = (icon: string) => {
	selectedIcon.value = icon;
	isDialogVisible.value = false;
};

const availableIcons = computed(() => icons);
const allVisibleIcons = computed(() => {
	if (!iconSearch.value || iconSearch.value === "") {
		return availableIcons.value;
	}
	const searchValue = iconSearch.value.toLowerCase();
	return availableIcons.value.filter((icon) =>
		icon.toLowerCase().includes(searchValue)
	);
});

const PaginatedIcons = computed(() => {
	if (allVisibleIcons.value?.length > 0) {
		const start = (page.value - 1) * itemsPerPage;
		const end = start + itemsPerPage;
		return allVisibleIcons.value.slice(start, end);
	}
	return [];
});

const noOfPages = computed(() =>
	Math.ceil(allVisibleIcons.value.length / itemsPerPage)
);
</script>

<template>
	<v-dialog v-model="isDialogVisible" max-width="600" min-height="300">
		<template v-slot:activator="{ props }">
			<v-sheet
				:key="selectedIcon"
				v-bind="props"
				@click="isDialogVisible = true"
				class="d-flex align-center justify-center rounded-t cursor-pointer item-picker"
				height="40"
				width="40"
			>
				<v-icon :icon="selectedIcon" />
			</v-sheet>
		</template>
		<v-card>
			<v-toolbar>
				<v-toolbar-title>
					<i class="fal fa-icons fa-xl mr-3"></i>
					Select an Icon
				</v-toolbar-title>
				<v-spacer />

				<v-btn icon @click="isDialogVisible = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-divider />
			<div class="pa-5">
				<div class="pb-2">
					Select your desired icon from the list below by clicking on it. You
					can filter the list by searching on a relevant object or action.
				</div>
				<div>
					<v-text-field
						v-model="iconSearch"
						variant="filled"
						label="Filter list"
					/>
				</div>
				<v-col class="ma-0 pa-0" cols="12">
					<v-btn
						v-for="(item, i) in PaginatedIcons"
						:key="`${i}-${item}`"
						@click="saveIcon(item)"
						variant="text"
						icon
					>
						<v-icon :icon="`fa: ${item}`"></v-icon>
					</v-btn>
					<div v-if="PaginatedIcons.length === 0" class="text-medium-emphasis">
						No icons found...
					</div>
				</v-col>
				<v-pagination
					class="mt-5"
					v-model="page"
					:length="noOfPages"
					:total-visible="6"
				/>
			</div>
		</v-card>
	</v-dialog>
</template>

<style scoped lang="scss">
.item-picker {
	border-bottom: 1px solid #bdc1c9;
	background-color: rgb(var(--color-background));
	flex-shrink: 0;
}
.item-picker:hover {
	border-bottom: 1px solid #979797;
	background-color: rgba(0, 0, 0, 0.05);
}
</style>
